import React from 'react';
import styles from './styles.module.scss';
import { OclockIcon } from '@features/ui/Icons';
import { formatDateDayTime, formatHour } from '@utils/formatDisplay';
import { I_SegmentInfo } from '@interfaces/common';

interface I_SegmentDetailProps {
    segmentInfo: I_SegmentInfo;
    luggageInfo: string | null; // 有可能沒有
    cabinInfo: string | null; // TF 沒有
}

const SegmentInfo = ({ segmentInfo, luggageInfo, cabinInfo }: I_SegmentDetailProps) => {
    const {
        FlightNo,
        DepDateTime,
        DepAirportName,
        DepAirport,
        ArrDateTime,
        ArrAirportName,
        ArrAirport,
        MarketingAirlineName,
        MarketingAirline,
        OperatingAirlineName,
        OperatingAirline,
        FlyDuration,
        AirlineEquipment,
        IsStopWait,
        DepTerminal,
        ArrTerminal
    } = segmentInfo;

    return (
        <div className={styles.segment}>
            <div className={styles.segmentInfo}>
                <div className={styles.time}>
                    <span className={styles.dep}>{formatDateDayTime(DepDateTime)}</span>
                    <span className={styles.during}>
                        {!IsStopWait && FlyDuration && (
                            <>
                                <OclockIcon fill="#666" />
                                {formatHour(FlyDuration)}
                            </>
                        )}
                    </span>
                    <span className={styles.arriv}>{formatDateDayTime(ArrDateTime)}</span>
                </div>

                <div className={styles.airport}>
                    <span>{`${DepAirport} ${DepAirportName} ${DepTerminal??""}`}</span>
                    <span>{`${ArrAirport} ${ArrAirportName} ${ArrTerminal??""}`}</span>
                </div>
            </div>

            <div className={styles.segmentDetail}>
                <div className={styles.airportInfo}>
                    <span>{`${MarketingAirlineName} ${MarketingAirline}${FlightNo}`}</span>
                    {MarketingAirline != OperatingAirline && (
                        <span className={styles.actualFlight}>
                            {`實際飛行 ${OperatingAirlineName}`}
                        </span>
                    )}
                </div>

                <div className={styles.bagInfo}>
                    {cabinInfo && <span>{cabinInfo}</span>}
                    {AirlineEquipment && <span>{`機型${AirlineEquipment}`}</span>}
                    {luggageInfo && <span>{luggageInfo}</span>}
                </div>
            </div>
        </div>
    );
};

export default SegmentInfo;
